<template>
  <div class="content-container">
    <search-comp @onSearch="attachData" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row align-end">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Thông tin đặt phòng</div>
                <div class="child-w-80">
                  <input v-model="searchParams.booking_info" type="text" />
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Thông tin đoàn</div>
                <div class="child-w-80">
                  <input v-model="searchParams.group_info" type="text" />
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="checkbox-container">
                <div class="checkbox-wrap">
                  <input
                    id="cpSpdTp3"
                    v-model="searchParams.isVirtual"
                    type="checkbox"
                  />
                  <label for="cpSpdTp3">Bao gồm phòng ảo</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <div class="grid-scroll flex mt-20">
      <div class="content-box flex column gap-20 flex-1">
        <div class="section-box outline">
          <div class="flex column gap-20 flex-1">
            <div class="das-form-container flex-1">
              <div class="das-form-title-container justify-space-between">
                <div class="das-form-title">
                  <span class="main-title">{{
                    $t('views.houseKeeper.reservationList')
                  }}</span>
                </div>
              </div>
              <hr />
              <div class="mt-10 flex-1">
                <GridVx
                  ref="agGrid"
                  :columns="columns"
                  dom-layout="scroll"
                  :rows="rows"
                  class="agGrid"
                  @rowClicked="getInvoiceRows"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="section-box outline">
          <div class="flex column gap-20 flex-1">
            <div class="das-form-container flex-1">
              <div class="das-form-title-container justify-space-between">
                <div class="das-form-title">
                  <span class="main-title">{{
                    $t('views.houseKeeper.reservationInvoiceList')
                  }}</span>
                </div>
              </div>
              <hr />
              <div class="mt-10 flex-1">
                <GridVx
                  ref="agGrid1"
                  :columns="invoiceCols"
                  :auto-size-cell="true"
                  dom-layout="scroll"
                  :auto-select-first-row="false"
                  :rows="invoiceRows"
                  class="agGrid"
                  @rowClicked="invoiceRowSelected = true"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="button-containers">
      <button
        :disabled="!invoiceRowSelected"
        class="btn primary small outline"
        @click="onDelete"
      >
        {{ $t('button.delete') }}
      </button>
      <button
        :disabled="!invoiceRowSelected"
        class="btn primary small outline"
        @click="editHkService(1)"
      >
        {{ $t('button.modify') }}
      </button>
      <button
        :disabled="!bookingRowSelected"
        class="btn primary small"
        @click="addHkService"
      >
        {{ $t('button.add') }}
      </button>
      <button
        :disabled="!invoiceRowSelected"
        class="btn primary small"
        @click="editHkService(2)"
      >
        {{ $t('button.detail') }}
      </button>
    </div>
    <AddHouseKeepingServiceDialog
      ref="AddHouseKeepingServiceDialog"
      v-model="kpItem"
      :kp-item-info="kpItemInfo"
      :kp-item-prop="kpItem"
      @submitDone="onHouseKeepingDialogDone"
    />
  </div>
</template>

<script>
import {
  CellRenderCheckboxReadonly,
  CellRenderTextInput,
  CellRenderCurrencyInput
} from '@/utils/cellRenders'
// import SingleCalendar from '@/components/ui/SingleCalendar.vue'
import {
  getListHouseKeepingServiceApi,
  getHouseKeepingServiceInvoicesApi,
  deleteHouseKeepingServiceInvoicesApi
} from '@/api/houseKeeper/house-keeping-service.js'
// import DasButton from '@/components/ui/DasButton.vue'
import AddHouseKeepingServiceDialog from './components/addHouseKeepingServiceDialog.vue'

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    CellRenderCheckboxReadonly,
    // eslint-disable-next-line vue/no-unused-components
    CellRenderTextInput,
    // eslint-disable-next-line vue/no-unused-components
    CellRenderCurrencyInput,
    // SingleCalendar,
    // DasButton,
    AddHouseKeepingServiceDialog
  },
  data() {
    return {
      bookingRowSelected: false,
      invoiceRowSelected: false,
      isDetailView: false,
      isEdit: false,
      kpItemInfo: {
        booking_code: null,
        confirm_code: null,
        arrive_date: null,
        depart_date: null,
        sub_booking_group_id: null,
        room_num: null,
        group: null,
        id: null
      },
      kpItem: {
        trading_date: this.$moment(new Date()).format('YYYY-MM-DD'),
        quantity: null,
        trans_page: null,
        invoice_discount_type: null,
        foc: false,
        invoice_discount_value: null,
        money_total: 0,
        note: null,
        room_service_group_id: null,
        room_service_group_name: null,
        sub_booking_group_id: null,
        room_transaction_id: null,
        fee: null,
        tax: null,
        products: []
      },
      searchParams: {
        page_size: null,
        page_num: null,
        booking_info: null,
        group_info: null,
        isVirtual: false
      },
      context: null,
      dialogFormVisible: false,
      columns: [
        {
          headerName: this.$t('grid.column.reservation'),
          field: 'booking_code',
          tooltipField: 'booking_code',
          maxWidth: 200
        },
        {
          headerName: this.$t('grid.column.confirm'),
          field: 'confirm_code',
          tooltipField: 'confirm_code',
          maxWidth: 200
        },
        {
          headerName: this.$t('grid.column.customerName'),
          field: 'name',
          tooltipField: 'name'
        },
        {
          headerName: this.$t('grid.column.room'),
          field: 'room_num',
          tooltipField: 'room_num',
          maxWidth: 200
        },
        {
          headerName: this.$t('grid.column.roomLevel'),
          field: 'room_level',
          tooltipField: 'room_level',
          flex: 1
        },
        {
          headerName: this.$t('grid.column.comeDate'),
          headerClass: 'ag-grid-header-cell-border-bottom',
          field: 'arrive_date',
          maxWidth: 200,
          valueGetter: params => {
            return this.$displayDate(params?.data?.arrive_date) || null
          }
        },
        {
          headerName: this.$t('grid.column.departDate'),
          headerClass: 'ag-grid-header-cell-border-bottom',
          field: 'depart_date',
          maxWidth: 200,
          valueGetter: params => {
            return this.$displayDate(params?.data?.depart_date) || null
          }
        },
        {
          headerName: this.$t('grid.column.free'),
          field: 'foc',
          tooltipField: 'price_code',
          headerClass: 'header-cell-center',
          cellRenderer: 'CellRenderCheckboxReadonly',
          cellClass: 'grid-cell-align-center',
          maxWidth: 100
        },
        {
          headerName: this.$t('grid.column.internal'),
          field: 'internal',
          cellRenderer: 'CellRenderCheckboxReadonly',
          headerClass: 'header-cell-center',
          cellClass: 'grid-cell-align-center',
          maxWidth: 100
        }
      ],
      invoiceCols: [
        {
          headerName: this.$t('grid.column.serviceDate'),
          field: 'trading_date',
          valueGetter: params => {
            return this.$displayDate(params?.data?.trading_date) || null
          },
          maxWidth: 140
        },
        {
          headerName: this.$t('grid.column.tradingCode'),
          field: 'trading_code',
          tooltipField: 'trading_code',
          maxWidth: 140
        },
        // {
        //   headerName: this.$t('grid.column.reference'),
        //   field: 'invoice_num',
        //   tooltipField: 'invoice_num',
        //   maxWidth: 140
        // },
        {
          headerName: this.$t('grid.column.moneyTotal'),
          field: 'money_total',
          valueGetter: params => {
            return Number(params.data?.money_total).toLocaleString('en') || null
          },
          maxWidth: 200
        },
        {
          headerName: this.$t('grid.column.foc'),
          field: 'foc',
          headerClass: 'header-cell-center',
          cellRenderer: 'CellRenderCheckboxReadonly',
          cellClass: 'grid-cell-align-center',
          maxWidth: 100
        },
        {
          headerName: this.$t('grid.column.desc'),
          field: 'description',
          tooltipField: 'description'
        },
        {
          headerName: this.$t('grid.column.note'),
          field: 'note',
          tooltipField: 'note'
        }
      ],
      columns2: [
        {
          headerName: 'Mã',
          field: 'code',
          tooltipField: 'code',
          maxWidth: 150
        },
        {
          headerName: 'Tên',
          field: 'name'
        },
        {
          headerName: 'Số tiền',
          field: 'price',
          maxWidth: 150,
          cellRenderer: 'CellRenderCurrencyInput'
        },
        {
          headerName: 'Số lượng',
          field: 'quantity',
          maxWidth: 100,
          cellRenderer: 'CellRenderTextInput',
          cellRendererParams: () => {
            return {
              type: 'number'
            }
          }
        },
        {
          headerName: '% Phí',
          field: 'fee',
          tooltipField: 'fee',
          maxWidth: 100
        },
        {
          headerName: '% Thuế',
          field: 'tax',
          tooltipField: 'tax',
          maxWidth: 100
        },
        {
          headerName: 'Giảm giá dịch vụ',
          field: 'discount',
          cellRenderer: 'CellRenderCurrencyInput'
        },
        {
          headerName: 'Thành tiền',
          field: 'money_total',
          valueGetter: params => {
            if (params.data?.money_total) {
              return Number(params.data.money_total).toLocaleString('en')
            } else {
              return null
            }
          }
        },
        {
          headerName: 'Giá mở',
          field: 'open_service',
          headerClass: 'header-cell-center',
          cellClass: 'grid-cell-align-center',
          maxWidth: 80,
          cellRenderer: 'CellRenderCheckboxReadonly'
        }
      ],
      rows: [],
      invoiceRows: [],
      rows2: []
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? null : this.resetInfo()
    }
    // 'kpItem.money_total'() {
    //   alert(this.kpItem.money_total)
    // }
  },
  beforeMount() {
    this.context = {
      componentParent: this
    }
  },
  async mounted() {
    this.attachData()
  },
  methods: {
    async onHouseKeepingDialogDone() {
      await this.getInvoiceRows()
    },
    // async addNewItem() {
    //   const agGrid = this.$refs.agGrid.gridApi
    //   const row = agGrid.getSelectedRows()[0]
    //   const data = this.$refs.AddHouseKeepingServiceDialog.kpItem
    //   const rows = this.$refs.AddHouseKeepingServiceDialog.rows2
    //   data.products = rows
    //   data.sub_booking_group_id = row.id
    //   if (data.invoice_discount_type === 1) {
    //     data.money_total -=
    //       0.01 * Number(data.invoice_discount_value) * data.money_total
    //   } else if (data.invoice_discount_type === 2) {
    //     data.money_total -= Number(data.invoice_discount_value)
    //   }
    //   await addHouseKeepingServiceInvoicesApi(data)
    //     .then(async res => {
    //       const message = res.message
    //       await this.getInvoiceRows()
    //       this.dialogFormVisible = false
    //       this.$message({
    //         type: 'success',
    //         message: this.$t(`successMsg.${message}`)
    //       })
    //     })
    //     .catch(error => {
    //       const message = error.response?.data?.message || 'default'
    //       this.$message({
    //         type: 'error',
    //         message: this.$t(`errorMsg.${message}`)
    //       })
    //     })
    // },
    // async updateItem() {
    //   const data = this.$refs.AddHouseKeepingServiceDialog.kpItem
    //   const rows = this.$refs.AddHouseKeepingServiceDialog.rows2
    //   data.products = rows
    //   if (data.invoice_discount_type === 1) {
    //     data.money_total -=
    //       0.01 * Number(data.invoice_discount_value) * data.money_total
    //   } else if (data.invoice_discount_type === 2) {
    //     data.money_total -= Number(data.invoice_discount_value)
    //   }
    //   await updateHouseKeepingServiceInvoicesApi(data)
    //     .then(async res => {
    //       const message = res.message
    //       await this.attachData()
    //       this.dialogFormVisible = false
    //       this.$message({
    //         type: 'success',
    //         message: this.$t(`successMsg.${message}`)
    //       })
    //     })
    //     .catch(error => {
    //       const message = error.response?.data?.message || 'default'
    //       this.$message({
    //         type: 'error',
    //         message: this.$t(`errorMsg.${message}`)
    //       })
    //     })
    // },
    // changeCurrencyInput(params, value, colName) {
    //   console.log('TRECKKK', colName)
    //   const idx = params.rowIndex
    //   const agGrid = this.$refs.agGrid2.gridApi
    //   switch (colName) {
    //     case 'price':
    //       this.rows2[idx]['price'] = value
    //       this.rows2[idx]['money_total'] =
    //         Number(value) * this.rows2[idx]['quantity'] -
    //         this.rows2[idx]['discount']
    //       agGrid.forEachNode(node => {
    //         if (node.rowIndex === idx) {
    //           node.setDataValue('money_total', this.rows2[idx]['money_total'])
    //         }
    //       })
    //       break
    //     case 'discount':
    //       // eslint-disable-next-line no-case-declarations
    //       this.rows2[idx]['discount'] = Number(value)
    //       this.rows2[idx]['money_total'] =
    //         Number(this.rows2[idx]['price']) *
    //           Number(this.rows2[idx]['quantity']) -
    //         Number(value)
    //       agGrid.forEachNode(node => {
    //         if (node.rowIndex === idx) {
    //           node.setDataValue(
    //             'money_total',
    //             Number(this.rows2[idx]['money_total'])
    //           )
    //         }
    //       })
    //       break
    //     default:
    //       break
    //   }
    //   let amount = 0
    //   this.rows2.map(item => {
    //     amount += item.money_total
    //   })
    //   this.kpItem.money_total = amount
    // },
    onReset() {},
    async editHkService(type) {
      // type 1 Edit
      const agGrid = this.$refs.agGrid.gridApi
      const row = agGrid.getSelectedRows()[0]
      Object.assign(this.kpItemInfo, row)
      const gridApi1 = this.$refs.agGrid1.gridApi
      const row1 = gridApi1.getSelectedRows()[0]
      //
      this.$refs.AddHouseKeepingServiceDialog.onEdit(row1.id)
    },
    changeInvoiceDiscountTp() {
      this.kpItem.invoice_discount_value = 0
    },
    // async updateItem() {
    //   if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
    //     return
    //   }
    //   this.kpItem.products = this.rows2.filter(
    //     item => Number(item.quantity) > 0
    //   )
    //   if (this.kpItem.products.length === 0) {
    //     this.$message({
    //       message: 'Cần chọn ít nhất một dịch vụ',
    //       type: 'error'
    //     })
    //     return
    //   }
    //   await updateHouseKeepingServiceInvoicesApi(this.kpItem)
    //     .then(async res => {
    //       const message = res.message
    //       await this.attachData()
    //       this.dialogFormVisible = false
    //       this.$message({
    //         type: 'success',
    //         message: this.$t(`successMsg.${message}`)
    //       })
    //     })
    //     .catch(error => {
    //       const message = error.response?.data?.message || 'default'
    //       this.$message({
    //         type: 'error',
    //         message: this.$t(`errorMsg.${message}`)
    //       })
    //     })
    // },
    // async addNewItem() {
    //   if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
    //     return
    //   }
    //   console.log('KAKA ', this.kpItem)
    //   this.kpItem.products = this.rows2.filter(
    //     item => Number(item.quantity) > 0
    //   )
    //   if (this.kpItem.products.length === 0) {
    //     this.$message({
    //       message: 'Cần chọn ít nhất một dịch vụ',
    //       type: 'error'
    //     })
    //     return
    //   }
    //   await addHouseKeepingServiceInvoicesApi(this.kpItem)
    //     .then(async res => {
    //       const message = res.message
    //       await this.getInvoiceRows()
    //       this.dialogFormVisible = false
    //       this.$message({
    //         type: 'success',
    //         message: this.$t(`successMsg.${message}`)
    //       })
    //     })
    //     .catch(error => {
    //       const message = error.response?.data?.message || 'default'
    //       this.$message({
    //         type: 'error',
    //         message: this.$t(`errorMsg.${message}`)
    //       })
    //     })
    // },
    resetInfo() {
      this.isEdit = false
      this.$refs.AddHouseKeepingServiceDialog.resetForm()
      // this.isDetailView = false
      // this.kpItemInfo = {
      //   booking_code: null,
      //   confirm_code: null,
      //   arrive_date: null,
      //   depart_date: null,
      //   room_num: null,
      //   group: null
      // }
      // this.kpItem = {
      //   trading_date: null,
      //   quantity: null,
      //   trans_page: null,
      //   invoice_discount_type: null,
      //   foc: true,
      //   invoice_discount_value: null,
      //   money_total: 0,
      //   note: null,
      //   room_service_group_id: null,
      //   room_service_group_name: null,
      //   sub_booking_group_id: null,
      //   room_transaction_id: null,
      //   include_tax_fee: null,
      //   products: []
      // }
      // this.rows2 = []
    },
    // textInputChange(params, value, colNm) {
    //   const idx = params.rowIndex
    //   this.rows2[idx]['money_total'] =
    //     value * Number(this.rows2[idx]['price']) -
    //     Number(this.rows2[idx]['discount'])
    //   const agGrid = this.$refs.agGrid2.gridApi
    //   agGrid.forEachNode(node => {
    //     if (node.rowIndex === idx) {
    //       node.setDataValue('money_total', this.rows2[idx]['money_total'])
    //     }
    //   })
    //   this.rows2[params.rowIndex][colNm] = value

    //   // use reduce
    //   let amount = 0
    //   this.rows2.map(item => {
    //     amount += item.money_total
    //   })
    //   this.kpItem.money_total = amount
    // },
    addHkService() {
      const agGrid = this.$refs.agGrid.gridApi
      const row = agGrid.getSelectedRows()[0]
      Object.assign(this.kpItemInfo, row)
      this.kpItem.sub_booking_group_id = row.id
      this.$refs.AddHouseKeepingServiceDialog.dialogFormVisible = true
    },
    async attachData() {
      const data = await getListHouseKeepingServiceApi(this.searchParams)
      this.rows = data.data.map(item => {
        if (item.group_name) {
          return {
            ...item,
            isFullWidthRow: true,
            name: item.group_name
          }
        } else {
          return item
        }
      })
      // this.bookingRowSelected = true
    },
    onDelete() {
      const gridApi = this.$refs.agGrid1.gridApi
      const row = gridApi.getSelectedRows()[0]
      if (!row) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectRow')
        })
        return false
      }
      const id = row.id
      const id_list = []
      id ? id_list.push(id) : null
      if (id_list.length === 0) {
        this.$alert('Bạn chưa chọn loại dịch vụ!', 'Error', {
          confirmButtonText: 'OK'
        })
      } else {
        this.$vxConfirm('Bạn chắc chắn muốn hủy loại dịch vụ này?', () => {
          deleteHouseKeepingServiceInvoicesApi({
            ids: id_list
          })
            .then(async res => {
              const message = res.message
              await this.getInvoiceRows()
              this.dialogFormVisible = false
              this.$message({
                type: 'success',
                message: this.$t(`successMsg.${message}`)
              })
            })
            .catch(error => {
              const message = error.response?.data?.message || 'default'
              this.$message({
                type: 'error',
                message: this.$t(`errorMsg.${message}`)
              })
            })
        })
      }
    },
    async getInvoiceRows() {
      const gridApi = this.$refs.agGrid.gridApi
      const id = gridApi.getSelectedRows()[0].id
      const param = {
        id: id
      }
      const data = await getHouseKeepingServiceInvoicesApi(param)
      this.invoiceRows = data.data
      this.bookingRowSelected = true
      this.invoiceRowSelected = false
    }
  }
}
</script>

<style lang="scss"></style>
